module.exports = __webpack_public_path__ + "toBride1-we-w-w.16f1add0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-w-w.jpg
// module id = 0sg+
// module chunks = 0